import {EntityType} from "../../../gd/const/item"
import ModelEntity from "../../model-entity"
import Relation from "../relation"
import RelatedItemsJson from "./related-items-json"
import {relationEntityFromJson} from "./entity-factory"

// One end of a link: either the item being viewed -- which the payload never
// sends, you are looking at it -- or one whose json came in `relatedItems`.
function buildEndpoint(itemType: EntityType, itemId: ID, itemsJson: RelatedItemsJson, currentItem: ModelEntity): ModelEntity | null {

    if (itemType === currentItem.itemType && itemId === currentItem.id) return currentItem

    return relationEntityFromJson(itemType, itemsJson.get(itemType, itemId))
}

// Builds the relations of a view payload's `relatedItems`. A relation row names
// its two items by type + id only, so both ends are resolved here.
export default function relationsFromJson(relatedItems: any, currentItem: ModelEntity): Relation[] {

    if (!relatedItems) return []

    const itemsJson = new RelatedItemsJson(relatedItems)

    return _.map(relatedItems.relations, (relationJson: any) => new Relation({
        ...relationJson,
        sourceItem: buildEndpoint(relationJson.sourceItemType, relationJson.sourceItemId, itemsJson, currentItem),
        targetItem: buildEndpoint(relationJson.targetItemType, relationJson.targetItemId, itemsJson, currentItem),
    }, currentItem))
}
